function format(type) {
  if (type === 'email') {
    return emailValidation;
  } else {
    throw new Error(`unhandled type: ${type}`);
  }
}

export { format };

function emailValidation(value) {
  return value && value.match(/^\s*\S+@\S+\.\S+\s*$/)
    ? null
    : 'Please enter a valid email address.';
}

function maxLength(length) {
  length = +length;

  return (value, context) => {
    value = value || '';
    return value.length <= length
      ? null
      : `${getFieldName(context)} may not be longer than ${length} characters.`;
  };
}

export { maxLength };

function pattern(pattern, errorMessage) {
  if (!(pattern instanceof RegExp)) {
    pattern = new RegExp(pattern);
  }

  return (value, context) => {
    errorMessage = errorMessage || getFieldName(context) + ' is not in the expected format.';
    value = value || '';

    return value.match(pattern)
      ? null
      : errorMessage;
  };
}

export { pattern };

function getFieldName(context = {}) {
  return context.label ? context.label : 'This field';
}